import React, { useCallback, useContext, useState } from 'react';

export interface IdentityContextValue {
    deafUserIdentity: string;
    setDeafUserIdentity: (name: string) => void;
    remoteVideoFlag: boolean | null;
    setRemoteVideoFlag: (value: boolean) => void;
}

export const IdentityContext = React.createContext<IdentityContextValue>({
    deafUserIdentity: '',
    setDeafUserIdentity: () => {},
    remoteVideoFlag: null,
    setRemoteVideoFlag: () => {},
});

export const IdentityConsumer = IdentityContext.Consumer;

export const IdentityProvider: React.FunctionComponent<React.PropsWithChildren> = ({
    children,
}) => {
    // const [trackSuscribedFlag, settrackSuscribedFlagState] = useState(false);
    const [remoteVideoFlag, setStateRemoteVideoTrackEnabled] = useState(false);

    const [deafUserIdentity, setDeafUserIdentityState] = useState('');

    const setDeafUserIdentity = useCallback(
        (identity: string) => {
            setDeafUserIdentityState(identity);
        },
        [setDeafUserIdentityState],
    );

    const setRemoteVideoFlag = useCallback(
        (value: boolean) => {
            setStateRemoteVideoTrackEnabled(value);
        },
        [setStateRemoteVideoTrackEnabled],
    );

    return (
        <IdentityContext.Provider
            value={{
                remoteVideoFlag,
                setRemoteVideoFlag,
                deafUserIdentity,
                setDeafUserIdentity,
            }}
        >
            {children}
        </IdentityContext.Provider>
    );
};

export const useIdentity = () => useContext(IdentityContext);
